import PostsAdapter from './base';

export default class Globalnotice extends PostsAdapter {
  modelNamePlural = 'globalnotices';
}
